// Function to get selected variant metadata
function getSelectedVariantMetadata(productInfoNode) {
  const selectedVariant = productInfoNode.querySelector('[data-selected-variant-metadata]')?.textContent;
  return !!selectedVariant ? JSON.parse(selectedVariant) : null;
}

// Render variant metadata
document.addEventListener("DOMContentLoaded", () => {
  // Subscribe to variantChange event
  theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (payload) => {

    // Access event data
    const { sectionId, productId, parsedHTML, variant } = payload.data;

    let getAllMetadata = getSelectedVariantMetadata(parsedHTML);

    // Remove all variant-metadata elements
    document.querySelectorAll('.refresh-on-change').forEach((element) => {
      element.textContent = ''
    });

    //  Loop all metadata and replace with variant-metadata-* all elements: * means the metadata name
    Object.keys(getAllMetadata).forEach((key) => {
      document.querySelectorAll(`.variant-metadata-${key}`).forEach((element) => {
        element.textContent = getAllMetadata[key];
      });
    });

    // Your custom logic here
    console.log("Section ID:", getAllMetadata);

  });

  setTimeout(function(){
    checkUrlForFilters();
  },50)
});

// If we're on a PLP and there are filters enabled in the URL and media card present, scroll down to results
function checkUrlForFilters() {
  var url_string = window.location.href;
  var url = new URL(url_string);
  var c = url.searchParams.get("filters");
  if(c) {
    let target = document.querySelector('#fast-simon-serp-app');
    if(target) {

      requestAnimationFrame(() => {
        setTimeout(() => {
          scrollToWithHeaderOffset(target, '.header-section.header-sticky');
        }, 0);
      });

    }
  }
}


function scrollToWithHeaderOffset(target, headerSelector = 'header') {
  const header = document.querySelector(headerSelector);
  const headerOffset = header ? header.offsetHeight : 0;
  const y = target.getBoundingClientRect().top + window.scrollY - headerOffset;
  window.scrollTo({ top: y, behavior: 'smooth' });
}
